import { useEffect, useState } from 'react'
import '../styles/login.scss'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Alert, Button, TextField } from '@mui/material'
import Cookies from 'universal-cookie'
import Loader from '../Shared/Loader'
import { loginCookieId } from '../utils/constants'

const cookies = new Cookies()

const apiUrl = process.env.REACT_APP_API_URL

export const Login = () => {
  const [loader, setLoader] = useState(false)
  const [alert, setAlert] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (cookies.get(loginCookieId)) navigate('/')
  }, [navigate])

  const handleSubmit = async ({ userName, password }) => {
    setAlert('')
    setLoader(true)
    await axios
      .post(`${apiUrl}/login`, { userName, password })
      .then(
        ({
          data: { sessionKey, loginSuccessful, message, awsCredentials, playerIsActive },
        }) => {
          setLoader(false)
          if (!loginSuccessful) {
            setAlert(message)
            return false
          }
          setAlert('Login successful')
          cookies.set(
            loginCookieId,
            { sessionKey, user: { name: userName }, awsCredentials, playerIsInactive: !playerIsActive },
            {
              path: '/',
              expires: new Date(2147483647 * 1000), // In the year 2038
            }
          )
          navigate('/')
        }
      )
      .catch((error) => {
        setLoader(false)
        setAlert(error.toString())
      })
  }

  return <LoginContents loader={loader} alert={alert} onSubmit={handleSubmit} />
}

const mainStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}

const formStyle = {
  textAlign: 'center',
}

const textFieldStyle = {
  margin: 10,
  width: '80%',
}

const alertStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}

const buttonStyle = {
  margin: 10,
}

export const LoginContents = ({ loader, alert, onSubmit }) => {
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const onSubmitForm = async (e) => {
    e.preventDefault()
    await onSubmit({ userName, password })
  }

  return (
    <div style={mainStyle}>
      <h1>Hey superstar! 👋 </h1>
      <h2>Please login 🚀</h2>
      <form style={formStyle} onSubmit={onSubmitForm}>
        <TextField
          style={textFieldStyle}
          placeholder="Username"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />
        <TextField
          style={textFieldStyle}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {loader && <Loader />}

        {alert && (
          <div style={alertStyle}>
            <Alert severity="error">{alert}</Alert>
          </div>
        )}

        <Button style={buttonStyle} type="submit" variant="contained">
          Login
        </Button>
      </form>
    </div>
  )
}
